import {
  FuelImportAction,
  FuelImportState,
  SET_FUEL_IMPORTS,
  SET_FUEL_IMPORTS_LOADED,
  SET_FUEL_IMPORT_FILTER,
  SET_SELECTED_FUEL_IMPORT,
} from '../types'

const initialState: FuelImportState = {
  fuelImports: [],
  isFuelImportsLoaded: false,
  fuelImportFilter: {
    name: '',
    importDateFrom: new Date(new Date().setDate(1)).getTime(),
    importDateTo: new Date().getTime(),
    supplierName: '',
    stationName: '',
  },
}

export const fuelImportReducer = (
  state = initialState,
  action: FuelImportAction
): FuelImportState => {
  switch (action.type) {
    case SET_FUEL_IMPORTS:
      return {
        ...state,
        fuelImports: action.payload,
      }
    case SET_FUEL_IMPORTS_LOADED:
      return {
        ...state,
        isFuelImportsLoaded: action.payload,
      }
    case SET_SELECTED_FUEL_IMPORT:
      return {
        ...state,
        selectedFuelImport: action.payload,
      }
    case SET_FUEL_IMPORT_FILTER:
      return {
        ...state,
        fuelImportFilter: action.payload,
      }
    default:
      return state
  }
}
